import axios from 'axios'

const API_PATH = 'api/v2/admins/settings'

const SettingsApiV2 = {
  /**
   * Get list of `Admin::Setting`
   */
  get: async (filters = '') => {
    const response = axios.get(API_PATH, { params: filters })
    return response
  },

  /**
   * Update `Setting`
   * @param {number} id Setting id
   * @param {any} value Setting value
   */
  update: async (id, value) => {
    const path = `${API_PATH}/${id}`
    const body = {
      setting: { value }
    }

    const response = axios.patch(path, body)
    return response
  }
}

export default SettingsApiV2
